import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Button } from '~/ui/core/button/Button';

type CommentsHeaderActionProps = {
    readonly isOpen: boolean;
    readonly onToggle: () => void;
};

export const CommentsHeaderAction: FunctionComponent<CommentsHeaderActionProps> = ({ isOpen, onToggle }) => {
    const translate = useTranslate();

    return (
        <Button
            aria-pressed={isOpen}
            data-testid="comments-header-action"
            size="sm"
            variant="secondary"
            onClick={onToggle}
        >
            {translate('pages.job-architecture-v2.comments.header-action.label')}
        </Button>
    );
};
